import {
    Configuration,
    LoanApplicationBorrowerAPIApiFactory,
    ProcessDefinitionManagerApiFactory,
    TaskManagerApiFactory,
    UISettingsApiFactory,
} from 'src/generated-api-client';
import { ResourceApiFactory } from 'src/services/customApi/ResourceApiFactory';

const apiConfig: Configuration | undefined = undefined;
const basePath = '';

const filesApiPath = '/api/file?';
export const getFileUrl = (filename: string) => {
    const searchParams = new URLSearchParams();
    searchParams.append('form', filename);

    return `${filesApiPath}${searchParams.toString()}`;
};

export const processDefinitionManagerApi = ProcessDefinitionManagerApiFactory(
    apiConfig,
    basePath,
);

export const taskManagerApi = TaskManagerApiFactory(apiConfig, basePath);
export const resourcesApi = ResourceApiFactory(apiConfig, basePath);

export const uiSettingsApi = UISettingsApiFactory(apiConfig, basePath);

export const applicationsApi = LoanApplicationBorrowerAPIApiFactory(
    apiConfig,
    basePath,
);
